module.exports = __webpack_public_path__ + "static/media/04.6d5a1685.jpg";